@if (iconName) {
  <cs-icon [name]="iconName" class="input-icon"></cs-icon>
}
<input class="text-input" #input [placeholder]="placeholder" [type]="type" [value]="value"
  (input)="handleChangeEvent($event)" [disabled]="disabled" [autocomplete]="autocomplete" [readonly]="readonly"
  [name]="name" [attr.text-left]="textLeft" [attr.text-right]="textRight" [min]="min" [max]="max" [checked]="checked"
  (focus)="handleFocus($event)" (blur)="handleBlur($event)" [class.has-icon]="iconName"
  [attr.role]="ariaRole ?? null" [attr.aria-autocomplete]="ariaRole === 'combobox' ? 'list' : null"
  [attr.aria-expanded]="ariaExpanded ?? null" [attr.aria-controls]="ariaControls ?? null"
  [attr.aria-activedescendant]="ariaActiveDescendant ?? null">